var map = {
	"./aiSecurity/sc.json": [
		4111,
		63
	],
	"./dataLeakage/sc.json": [
		4112,
		66
	],
	"./ppd/sc.json": [
		4113,
		69
	],
	"./ransomware/sc.json": [
		4114,
		72
	],
	"./socialMedia/sc.json": [
		4115,
		75
	],
	"./whatsApp/sc.json": [
		4116,
		78
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1335;
module.exports = webpackAsyncContext;